<template>
  <!--
    Sininho de MENSAGENS DA EQUIPE (separado do sininho de notificações).
    - Ícone de balões (fa-comments) para não confundir com o sino (fa-bell).
    - Contador numérico, não só um ponto: "3" informa mais que "algo".
    - Área de clique de 44x44 px (WCAG 2.5.5 / Lei de Fitts).
  -->
  <button
    type="button"
    :class="[
      'chat-nav-btn',
      { 'chat-nav-btn--has-unread': total > 0, 'chat-nav-btn--open': open },
    ]"
    :aria-label="ariaLabel"
    :aria-expanded="open ? 'true' : 'false'"
    aria-controls="chat-incoming-popup"
    :title="ariaLabel"
    @click="toggle"
  >
    <i class="fas fa-comments chat-nav-btn__icon" aria-hidden="true"></i>

    <span v-if="total > 0" class="chat-nav-btn__badge" aria-hidden="true">
      {{ total > 99 ? "99+" : total }}
    </span>
    <!-- O anúncio de "mensagem nova" fica no popup (evita aviso duplicado) -->
  </button>
</template>

<script>
import chatService from "../../services/chatService";

export default {
  name: "ChatNavButton",

  data() {
    return {
      // Referência ao estado reativo do serviço (mesmo objeto em todo o app)
      chat: chatService.state,
    };
  },

  computed: {
    total() {
      return this.chat.messages.length;
    },

    open() {
      return this.chat.popupOpen;
    },

    ariaLabel() {
      if (this.total === 0) return "Mensagens da equipe: nenhuma nova";
      if (this.total === 1) return "Mensagens da equipe: 1 mensagem nova";
      return `Mensagens da equipe: ${this.total} mensagens novas`;
    },
  },

  methods: {
    toggle() {
      if (this.open) {
        chatService.snooze();
      } else {
        chatService.openPopup();
        // Teclado: quem abriu pelo botão recebe o foco dentro do popup
        this.$nextTick(() => {
          const el = document.getElementById("chat-incoming-popup");
          if (el) el.focus();
        });
      }
    },
  },
};
</script>

<style scoped>
.chat-nav-btn {
  --chat-nav-badge-bg: #c2410c; /* laranja escuro: contraste 5.2:1 com branco */
  --chat-nav-focus: #fde68a;

  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  padding: 0;
  border: 2px solid transparent;
  border-radius: 12px;
  background: transparent;
  color: #ffffff;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.chat-nav-btn:hover,
.chat-nav-btn--open {
  background: rgba(255, 255, 255, 0.15);
}

/* Foco visível e forte: navbar é azul, então usamos amarelo claro */
.chat-nav-btn:focus {
  outline: none;
}

.chat-nav-btn:focus-visible {
  border-color: var(--chat-nav-focus);
  box-shadow: 0 0 0 2px rgba(253, 230, 138, 0.5);
}

.chat-nav-btn__icon {
  font-size: 18px;
  line-height: 1;
}

.chat-nav-btn__badge {
  position: absolute;
  top: 2px;
  right: 0;
  min-width: 20px;
  height: 20px;
  padding: 0 5px;
  border: 2px solid #ffffff;
  border-radius: 10px;
  background: var(--chat-nav-badge-bg);
  color: #ffffff;
  font-size: 11px;
  font-weight: 700;
  line-height: 16px;
  text-align: center;
}

/* Pulso discreto apenas quando há mensagem não lida */
.chat-nav-btn--has-unread .chat-nav-btn__badge {
  animation: chat-nav-pulse 2s ease-in-out infinite;
}

@keyframes chat-nav-pulse {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.12);
  }
}

@media (prefers-reduced-motion: reduce) {
  .chat-nav-btn--has-unread .chat-nav-btn__badge {
    animation: none;
  }
}
</style>